export type MaintenanceTranslation = {
  message: string;
  title: string;
};

export const maintenanceTranslation: MaintenanceTranslation = {
  message: 'We are performing maintenance in the app. We will be back soon.',
  title: 'Maintenance in progress',
};
